/**
 * Dutch copy for global search.
 *
 * Registered with one line in src/i18n/nl/index.ts:
 * `mergeTranslations(..., nlSearchMessages)`.
 */
export const nlSearchMessages = {
  crm: {
    search: {
      label: "Zoeken",
      placeholder: "Zoeken",
      placeholder_long: "Zoek contacten, bedrijven en notities",
      open: "Zoeken",
      empty: "Geen resultaten",
      error: "Zoeken lukt niet",
      groups: {
        contact: "Contactpersonen",
        company: "Bedrijven",
        note: "Notities",
      },
    },
  },
};
